import React, { useState } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { Button, Box, Dialog, DialogContent, Stack, Typography, Modal, Tooltip as TT, IconButton, ButtonGroup, Grid } from '@mui/material'
import { Doughnut } from 'react-chartjs-2'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import _ from 'lodash'


import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { selectGlobalSettingEntities } from '../../../reducers/reference_settings';
import { selectViewInstanceById } from '../../../reducers/reuseable_vi';
import { useNavigate, createSearchParams } from 'react-router-dom'
import AssessmentEditButton from './AssessmentEditButton';
import AssessmentPersonalReportButton from './AssessmentPersonalReportButton';
import AssessmentPhysicianSummaryButton from './AssessmentPhysicianSummaryButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
ChartJS.register(ArcElement, Tooltip, Legend);


const PreviousAssessmentTableMobile = (props) => {
    const navigate = useNavigate()
    const graphcolors = ['#c0c0c0', '#4eb748', '#E7C61E', '#E6323A']
    const { user: currentUser } = useSelector((state) => state.auth);
    const settings = useSelector(state => selectGlobalSettingEntities(state))
    const viewInstance = useSelector(state => selectViewInstanceById(state, "ProfileDemographics"))
    const PrevAsmts = viewInstance?.ProfileVI?.MenuProfile?.PreviousAssessmentsFrame?.PreviousAssessmentsSQL ?
        viewInstance.ProfileVI.MenuProfile.PreviousAssessmentsFrame.PreviousAssessmentsSQL
        : []
    const PrevAsmtsText = viewInstance?.ProfileVI?.MenuProfile?.PreviousAssessmentsFrame.PreviousAssessmentTextObject ?
        viewInstance.ProfileVI.MenuProfile.PreviousAssessmentsFrame.PreviousAssessmentTextObject
        : {}
    const GetColor = (score) => {

        const vg = parseInt((score <= 39 && score >= 0) ? 3 : (score <= 69 && score >= 0) ? 2 : (score <= 100 && score >= 0) ? 1 : 0)
        return graphcolors[vg]
    }






    const labelCenter = {
        id: "labelCenter",
        beforeDraw: function (chart) {
            var width = chart.width,
                height = chart.height,
                ctx = chart.ctx;
            ctx.restore();
            var fontSize = (height / 75).toFixed(2);
            ctx.font = fontSize + "em sans-serif";
            ctx.textBaseline = "top";
            var text = chart.config.options.beforeDrawHack,
                textX = Math.round((width - ctx.measureText(text).width) / 2),
                textY = Math.round((height - ctx.measureText(text).width) / 2);

            ctx.fillText(text, textX, textY);
            ctx.save();
        }
    };

    const OWSDoughnut = ({ row }) => {
        let OWS = parseInt(row.Ows, 0)
        const Color = row.IsCompleted === '1' ? GetColor(OWS) : GetColor(-1)
        const data = {
            datasets: [
                {

                    data: row.IsCompleted === '1' ? [OWS, 100 - OWS] : [0, 100],
                    backgroundColor: [
                        Color,
                        Color + "40"
                    ],
                    borderColor: [
                        'rgba(255, 99, 132, 0)',
                        'rgba(54, 162, 235, 0)',
                    ],
                    borderWidth: 0,
                },
            ],
        }
        const options = {
            responsive: true,
            cutout: '80%',
            animation: {
                animateRotate: true,
                render: false,
            },
            events: [],
            tooltips: {
                enabled: false
            },
            beforeDrawHack: row.IsCompleted === '1' ? OWS : "-",
            plugins: {
                legend: {
                    display: false
                },
                labelCenter: {
                    labels: [
                        {
                            text: row.IsCompleted === '1' ? OWS : "-",
                            font: {
                                size: 3.25,
                                unit: "rem",
                                color: 'black',
                                style: "bold"
                            }
                        }
                    ]
                }

            }
        }
        const plugins = [labelCenter]
        return (
            <Box height={"60px"} width={"60px"}>

                <Stack direction={"column"} spacing={2}>
                    <Doughnut data={data} options={options} plugins={plugins} width={"100%"} />
                </Stack>
            </Box>
        )
    }



    const CompletedControl = ({ row }) => {

        return row.IsCompleted === '1' ? <TaskAltIcon color={graphcolors[1]} /> : <></>
    }

    const AssessmentButtonGroup = ({ row, mobile }) => {
        return <ButtonGroup>
            <AssessmentPhysicianSummaryButton row={row} mobile={mobile ? true : false} />
            <AssessmentPersonalReportButton row={row} mobile={mobile ? true : false} />
        </ButtonGroup>
    }

    /*
    "AssmtGuid": "B43122FB-9A5F-4671-B436-C5BE6DE1DD37",
    "AssessmentProductGuid": "42AB6722-BAFC-4A59-8996-10A7C402C03E",
    "DateStarted": "2024-07-11",
    "DateFirstCalc": "2024-07-11",
    "DateMostRecentCalc": "2024-07-11",
    "SurveyContent": "Risk of Breast Cancer",
    "Ows": "29",
    "OwsCaption": "",
    "PrViGuid": "941B82A8-9B89-42CB-9601-C1567D6E38F0",
    "PsViGuid": "",
    "IsCompleted": "1",
    "EditAssessmentVisible": "1"
    */


    const AssessmentBox = ({ row }) => {

        return (
            <Grid container direction={"row"} spacing={0} justifyContent={"center"} alignItems={"center"} sx={{ borderBottom: 1, borderColor: "#00000040", p: 1 }}>
                <Grid item xs={4}>
                    <Stack direction={"column"} spacing={2}>
                        <OWSDoughnut row={row} />
                        <Typography variant={"caption"}>{row.DateStarted}</Typography>
                    </Stack>
                </Grid>
                <Grid item xs={8}>
                    <Stack direction={"column"} spacing={2}>
                        <Stack direction={"row"} spacing={2}>
                            <Typography variant={"body1"}>
                                {row.SurveyContent}
                            </Typography>
                            <AssessmentEditButton row={row} />
                        </Stack>
                        <Stack direction={"row"} spacing={2}>
                            <AssessmentButtonGroup row={row} mobile={true}  />
                        </Stack>
                    </Stack>
                </Grid>
            </Grid>
        )
    }

    const AssessmentTable = () => {
        return (<Box>
            {
                PrevAsmts.map((row, i) => {
                    return (<AssessmentBox row={row} key={"previous_assessment_" + i} />)
                })
            }
        </Box>
        )
    }

    return (
        <Box>
            <AssessmentTable />
        </Box>
    )

}
export default PreviousAssessmentTableMobile